import React from 'react'
import LinkButton from '@components/common/LinkButton'
import BasicCard from '../../productcards/BasicCard'
import imgShopBestSeller from '@images/Home/shop-best-sellers.webp'
import imgNewArrivals from '@images/Home/shop-new-arrivals.webp'
import { navApparelMenu, navCollectionMenu, navSwimMenu } from '@staticdata/navigation-data'
import clsx from 'clsx'

const MegaMenu = ({ isOpen, handleMegaMenu }) => {

	const swimMenu = navSwimMenu
	const apparelMenu = navApparelMenu
	const collectionMenu = navCollectionMenu

	return (
		<React.Fragment>
			<div className={clsx('w-auto lg:w-full bg-white absolute z-[49]', isOpen ? 'absolute' : 'hidden')} onMouseLeave={() => handleMegaMenu(false)}>
				<div className="hidden lg:grid grid-cols-1 lg:grid-cols-2 max-w-[1440px] px-4 xl:px-40 lg:px-10 py-12 h-max lg:h-auto overflow-y-auto mx-auto">
					<div className="grid grid-flow-col">
						<div className="">
							<button onClick={() => { }}>
								<h3 className='mb-4'>SWIM</h3>
							</button>
							<div className="flex flex-col gap-y-2">
								{swimMenu.map((item, index) => {
									return <LinkButton className={'hover:underline hover:underline-offset-2'} label={item.label} key={`swim-${index}`} to={item.url} ariaLabel={item?.label} />;
								})}
							</div>
						</div>

						<div className="">
							<button onClick={() => { }}>
								<h3 className='mb-4'>APPAREL</h3>
							</button>
							<div className="flex flex-col gap-y-2">
								{apparelMenu.map((item, index) => {
									return <LinkButton className={'hover:underline hover:underline-offset-2'} label={item.label} key={`apparel-${index}`} to={item.url} ariaLabel={item?.label} />;
								})}
							</div>
						</div>

						<div className="">
							<button onClick={() => { }}>
								<h3 className='mb-4'>COLLECTION</h3>
							</button>
							<div className="flex flex-col gap-y-2">
								{collectionMenu.map((item, index) => {
									return <LinkButton className={'hover:underline hover:underline-offset-2'} label={item.label} key={`collection-${index}`} to={item.url} ariaLabel={item?.label} />;
								})}
							</div>
						</div>
					</div>

					<div className='grid grid-flow-col gap-x-4 pt-6 lg:pt-0 justify-center lg:justify-start'>
						<BasicCard
							data={{
								label: "SHOP BEST SELLERS",
								image: imgShopBestSeller,
							}}
							link={'/collections/bestsellers/'}
							className="relative w-full xl:w-64 h-[220px] md:h-auto overflow-hidden cursor-pointer"
							ariaLabel='SHOP BEST SELLERS'
						/>

						<BasicCard
							data={{
								label: "SHOP NEW ARRIVALS",
								image: imgNewArrivals,
							}}
							link={'/collections/new-arrivals/'}
							className="relative w-full xl:w-64 h-[220px] md:h-auto overflow-hidden cursor-pointer"
							ariaLabel='SHOP NEW ARRIVALS'
						/>
					</div>
				</div>

				{/* <section className='flex lg:hidden'>
          test
        </section> */}
			</div>
		</React.Fragment>
	);
}

export default MegaMenu